import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page6 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="react-print-none">
                                                <div className="lightgreencontentbg keyquestionpad uiheading ">
                                                    <p><span className="subtiltereg">By when will you have done this?</span>
                                                    </p>
                                                </div>
                                                <ul className="taskul">
                                                    <li>You will have a list by now of actions which will help you
                                                        use your signature strengths more, and
                                                        how you can overcome any barriers. Now, set yourself a date
                                                        by which you will have completed
                                                        these actions, so that you have something to work towards
                                                        and use to review your progress.
                                                    </li>
                                                </ul>
                                                <span className="uiheading">   <p><span
                                                    className="brown brownbold">Example:</span></p></span>
                                                <ul className="greenbullet-list">
                                                    <li>Speak to the manager about which projects I work on by…</li>
                                                    <li>Speak to the project managers about new projects – ongoing
                                                        but aim to be on two new
                                                        projects by…
                                                    </li>
                                                    <li>Shadow sales pitches – shadow two by…</li>
                                                    <li>Attend sales pitch as part of team by…</li>
                                                </ul>
                                                <div className="lightgreencontentbg keyquestionpad uiheading  ">
                                                    <p>When setting timescales, be realistic and allow slightly more
                                                        time than you think you need
                                                        to allow for the unexpected. When you feel under pressure,
                                                        development can be one of the
                                                        first things to fall off your ‘to do’ list, and if you keep
                                                        extending your timescales you are less
                                                        likely to stick to them.</p>
                                                </div>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>CREATING THE BEST ACTION PLAN
                                            </div>

                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print task">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />

                                            <br/>
                                            <div className="mobile-scroll">
                                                <table width="100%" border="0" cellSpacing="0"
                                                       cellPadding="0" className="ilead_v_sport  ">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" align="left"
                                                            className="green_curve table_heading_padding">
                                                            <div>Strength</div>
                                                        </th>
                                                        <th width="20%" align="left" valign="middle"
                                                            className="table_heading_padding">
                                                            <ol className="table_heading_ol">
                                                                <li>Where do I currently use it?</li>
                                                            </ol>
                                                        </th>
                                                        <th width="20%" align="left" valign="middle"
                                                            className="table_heading_padding">
                                                            <ol className="table_heading_ol" start="2">
                                                                <li>How often?</li>
                                                            </ol>
                                                        </th>
                                                        <th width="20%" align="left" valign="middle"
                                                            className=" green_curve1 table_heading_padding">
                                                            <ol className="table_heading_ol" start="3">
                                                                <li>Can I do more?</li>
                                                            </ol>
                                                        </th>

                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="1"
                                                                      value={pageData?.Strength?.[1]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="1"
                                                                      value={pageData?.WhereDoICurrentlyUseIt?.[1]}
                                                                      onChange={this.props.handleChangePageData('WhereDoICurrentlyUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="1"
                                                                      value={pageData?.HowOften?.[1]}
                                                                      onChange={this.props.handleChangePageData('HowOften')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="1"
                                                                      value={pageData?.CanIDoMore?.[1]}
                                                                      onChange={this.props.handleChangePageData('CanIDoMore')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="2"
                                                                      value={pageData?.Strength?.[2]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="2"
                                                                      value={pageData?.WhereDoICurrentlyUseIt?.[2]}
                                                                      onChange={this.props.handleChangePageData('WhereDoICurrentlyUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="2"
                                                                      value={pageData?.HowOften?.[2]}
                                                                      onChange={this.props.handleChangePageData('HowOften')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="2"
                                                                      value={pageData?.CanIDoMore?.[2]}
                                                                      onChange={this.props.handleChangePageData('CanIDoMore')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="3"
                                                                      value={pageData?.Strength?.[3]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="3"
                                                                      value={pageData?.WhereDoICurrentlyUseIt?.[3]}
                                                                      onChange={this.props.handleChangePageData('WhereDoICurrentlyUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="3"
                                                                      value={pageData?.HowOften?.[3]}
                                                                      onChange={this.props.handleChangePageData('HowOften')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="3"
                                                                      value={pageData?.CanIDoMore?.[3]}
                                                                      onChange={this.props.handleChangePageData('CanIDoMore')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="4"
                                                                      value={pageData?.Strength?.[4]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="4"
                                                                      value={pageData?.WhereDoICurrentlyUseIt?.[4]}
                                                                      onChange={this.props.handleChangePageData('WhereDoICurrentlyUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="4"
                                                                      value={pageData?.HowOften?.[4]}
                                                                      onChange={this.props.handleChangePageData('HowOften')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="4"
                                                                      value={pageData?.CanIDoMore?.[4]}
                                                                      onChange={this.props.handleChangePageData('CanIDoMore')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="5"
                                                                      value={pageData?.Strength?.[5]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="5"
                                                                      value={pageData?.WhereDoICurrentlyUseIt?.[5]}
                                                                      onChange={this.props.handleChangePageData('WhereDoICurrentlyUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="5"
                                                                      value={pageData?.HowOften?.[5]}
                                                                      onChange={this.props.handleChangePageData('HowOften')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="5"
                                                                      value={pageData?.CanIDoMore?.[5]}
                                                                      onChange={this.props.handleChangePageData('CanIDoMore')}/>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page7')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
        ;
    }
}